import { Persona } from './../models/Persona';
import { EmpresaService } from './../service/empresa/empresa.service';
import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators, AbstractControl, MinLengthValidator } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { RiesgoService } from "../service/riesgo/riesgo.service";
import { NotificacionService } from "../service/notificaciones/notificacion.service";
import { EncryptDecryptService } from "../service/security/encrypt-decrypt.service";

@Component({
  selector: "app-evaluaFactura",
  templateUrl: "./evaluaFactura.component.html",
  styleUrls: ["./evaluaFactura.component.scss"],
})

export class EvaluaFacturaComponent implements OnInit {
  top: any = 0;
  respuesta: boolean;
  Estado: string;
  evalua: FormGroup;
  prov: any;
  paginaWeb: boolean = false;
  // RUC DEL ADQUIRENTE DE PRUEBA: 20390724919
  adq: any;
  cel: any;
  correo: any;
  TipoDoc: any;
  NroDoc: any;
  Nombre: any;
  ranking: any;
  data: any;
  codValid: number;
  encryptedText: any;
  decryptedText: any;
  loadingPrincipal: boolean = false;
  loading: boolean = false;
  loadingSentinel: boolean = false;
  loadingInicial: boolean = false;
  arrDataAdjunto = [{
    "rucProveedor": "",
    "rucAdquirente": "",
    "celular": "",
    "correo": "",
    "evaluacion": "",
  }];
  arrDataCorreo = {
    "to": [{
      "email": "",
      "nombre": ""
    }],
    "asunto": "",
    "contenido": ""
  };
  html: string;
  persona: any = {};

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private riesgoService: RiesgoService,
    private notificacionService: NotificacionService,
    private encryptDecryptService: EncryptDecryptService,
    private empresasService: EmpresaService
  ) {
    this.prov = localStorage.getItem("rucProv");
    this.cel = localStorage.getItem("celular");
    this.correo = localStorage.getItem("email");
    this.TipoDoc = localStorage.getItem("TipoDoc");
    this.NroDoc = localStorage.getItem("NroDoc");
    if (this.NroDoc == null || this.NroDoc == undefined) {
      this.NroDoc = '';
    }
    this.Nombre = localStorage.getItem("Nombre");
  }

  ngOnInit() {
    this.loadingInicial = true;
    this.route.paramMap.subscribe(params => {
      if (params.has("rucAdq")) {
        this.loadingPrincipal = true;
        this.paginaWeb = true;
        this.evalua = new FormGroup({
          Prov: new FormControl(params.get("rucProv"), [Validators.required, Validators.pattern("[0-9]{11}$")]),
          Adq: new FormControl(params.get("rucAdq"), [Validators.required, Validators.pattern("[0-9]{11}$")]),
          Cel: new FormControl(params.get("celular"), [Validators.required, Validators.pattern("^9[0-9]{8}$")]),
          Correo: new FormControl(params.get("correo"), [Validators.required, Validators.pattern("^[a-zA-Z0-9_.+-]{3,}@[a-zA-Z0-9-]{3,}.[a-zA-Z0-9-.]{2,}$")]),
          Tipo_Documento_Identidad: new FormControl(params.get("tipoDoc"), []),
          Nro_Documento_Identidad: new FormControl(params.get("numDoc"), [Validators.required, Validators.pattern("[0-9]{8}$"), this.validar.bind(this)]),
          Nombre_Completo: new FormControl(params.get("nombre").replace(/[+]/gi, ' '), []),
        });
        this.evalua.get("Tipo_Documento_Identidad").valueChanges
        .subscribe(data=> {
          this.changeValidatorsTipoDoc()
        })
        this.evalua.get("Nro_Documento_Identidad").valueChanges
        .subscribe(data=> {
          this.changeValidatorsNumDoc()
        })



      }
      else {
        this.evalua = new FormGroup({
          Prov: new FormControl(this.prov, [Validators.required, Validators.pattern("[0-9]{11}$")]),
          Adq: new FormControl(this.adq, [Validators.required, Validators.pattern("[0-9]{11}$")]),
          Cel: new FormControl(this.cel, [Validators.required, Validators.pattern("^9[0-9]{8}$")]),
          Correo: new FormControl(this.correo, [Validators.required, Validators.pattern("^[a-zA-Z0-9_.+-]{3,}@[a-zA-Z0-9-]{3,}.[a-zA-Z0-9-.]{2,}$")]),
          Tipo_Documento_Identidad: new FormControl(this.TipoDoc, []),
          Nro_Documento_Identidad: new FormControl(this.NroDoc, [Validators.required, Validators.pattern("[0-9]{8}$"), this.validar.bind(this)]),
          Nombre_Completo: new FormControl(this.Nombre, []),
        });
        this.evalua.get("Tipo_Documento_Identidad").valueChanges
        .subscribe(data=> {
          this.changeValidatorsTipoDoc()
        })
        this.evalua.get("Nro_Documento_Identidad").valueChanges
        .subscribe(data=> {
          this.changeValidatorsNumDoc()
        })
      }
    })
    const ctrl = this.evalua.get('Nombre_Completo');
    if (this.evalua.controls['Tipo_Documento_Identidad'].value == 'D') {
      this.evalua.controls["Nombre_Completo"].clearValidators();
      ctrl.disable();
    }else if(this.evalua.controls['Tipo_Documento_Identidad'].value == 'C'){
      this.evalua.controls["Nro_Documento_Identidad"].setValidators([Validators.required, Validators.pattern("[0-9]{8}$")]);
      this.evalua.controls["Nombre_Completo"].setValidators([Validators.required,Validators.minLength(6)]);
    }else{
      this.evalua.controls["Nro_Documento_Identidad"].setValidators([Validators.required, Validators.pattern("[0-9]{9,11}$")]);
      this.evalua.controls["Nombre_Completo"].setValidators([Validators.required,Validators.minLength(6)]);
    }
    this.evalua.get("Nro_Documento_Identidad").updateValueAndValidity();
    this.evalua.get("Nombre_Completo").updateValueAndValidity();

    this.loadingInicial = false;
    if (this.paginaWeb &&this.evalua.valid) {
      this.evaluar()
    }
  }

  validar(control: AbstractControl) {
    if (control.value.length == 8 && !this.loadingInicial) {
      this.obtenerPersona()
    }
    return true;
  }
  changeValidatorsNumDoc(){
    if (this.evalua.get("Nro_Documento_Identidad").invalid) {
      this.evalua.controls['Nombre_Completo'].setValue('');
    }
  }
  changeValidatorsTipoDoc() {

    if (this.evalua.get("Tipo_Documento_Identidad").value=="D") {
      this.evalua.controls['Nro_Documento_Identidad'].setValue('');
      this.evalua.controls["Nro_Documento_Identidad"].setValidators([Validators.required, Validators.pattern("[0-9]{8}$"), this.validar.bind(this)]);
      this.evalua.controls["Nombre_Completo"].clearValidators();
    }else if (this.evalua.get("Tipo_Documento_Identidad").value=="C"){
      this.evalua.controls["Nro_Documento_Identidad"].setValidators([Validators.required, Validators.pattern("[0-9]{8}$"), this.validar.bind(this)]);
      this.evalua.controls["Nombre_Completo"].setValidators([Validators.required,Validators.minLength(6)]);
    }
    else {
      this.evalua.controls["Nro_Documento_Identidad"].setValidators([Validators.required, Validators.pattern("[0-9]{9,11}$")]);
      this.evalua.controls["Nombre_Completo"].setValidators([Validators.required,Validators.minLength(6)]);
    }

    this.evalua.get("Nro_Documento_Identidad").updateValueAndValidity();
    this.evalua.get("Nombre_Completo").updateValueAndValidity();


  }



  validarTipoDoc() {
    const Nro_Documento_Identidad = this.evalua.get('Nro_Documento_Identidad');

        if (this.evalua.controls['Tipo_Documento_Identidad'].value == 'D') {
          Nro_Documento_Identidad.setValidators([Validators.required, Validators.pattern("[0-9]{8}$"), this.validar.bind(this)]);
        }
        Nro_Documento_Identidad.updateValueAndValidity();
  }

  obtenerScoreProveedor() {
    this.loading = true;
    this.riesgoService.obtenerScore(this.evalua.controls["Prov"].value).subscribe(
      (res) => {
        this.Estado = res["Estado"];
        if (this.Estado == "X") {
          this.respuesta = false;
          this.riesgoService.Respuesta = this.respuesta;
          this.loading = false;
          return;
        }
        this.riesgoService.provScore = res["Scoring_Puntaje"];
        this.loading = false;
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  obtenerScoreAdquirente() {
    this.loading = true;
    this.riesgoService.obtenerScore(this.evalua.controls["Adq"].value).subscribe(
      (res) => {
        this.Estado = res["Estado"];
        if (this.Estado == "X") {
          this.respuesta = false;
          this.riesgoService.Respuesta = this.respuesta;
          this.loading = false;
          return;
        }
        this.riesgoService.adqScore = res["Scoring_Puntaje"];
        this.loading = false;
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  evaluar() {
    this.loading = true;
    localStorage.setItem("rucProv", this.evalua.controls["Prov"].value);
    localStorage.setItem("rucAdqui", this.evalua.controls["Adq"].value);
    localStorage.setItem("email", this.evalua.controls["Correo"].value);
    localStorage.setItem("celular", this.evalua.controls["Cel"].value);
    localStorage.setItem("TipoDoc", this.evalua.controls["Tipo_Documento_Identidad"].value);
    localStorage.setItem("NroDoc", this.evalua.controls["Nro_Documento_Identidad"].value);
    localStorage.setItem("Nombre", this.evalua.controls["Nombre_Completo"].value);

    this.riesgoService.rucAdq = this.evalua.controls["Adq"].value;

    this.riesgoService.obtenerRanking(this.evalua.controls["Adq"].value).subscribe(
      (res) => {
        this.riesgoService.top10K = res;
        if (res > 6000) {
          this.respuesta = false;
          this.riesgoService.Respuesta = this.respuesta;
          this.loading = false;
          this.arrDataAdjunto[0].evaluacion = `¡Hola! Tu cliente ${this.evalua.controls["Adq"].value} no pre-califica para la venta de tu factura.`;
          this.enviarCorreo();
          this.loadingPrincipal = false;
          this.router.navigate([`respuesta-no-precalifica/${this.evalua.controls["Adq"].value}`]);
        } else {
          // ME SIRVE EL RANKING PARA MANDARLO POR CORREO
          let ruta = "";
          if (res > 0 && res <= 3000) {
            this.arrDataAdjunto[0].evaluacion = `¡Hola! Tu cliente ${this.evalua.controls["Adq"].value} pre-califica para la venta de tu factura en moneda Soles y Dólares.`;
            ruta = `respuesta-precalifica/${this.evalua.controls["Adq"].value}`;
            this.enviarSms();
          } else if (res > 3000 && res <= 6000) {
            this.arrDataAdjunto[0].evaluacion = `¡Hola! Tu cliente ${this.evalua.controls["Adq"].value} pre-califica para la venta de tu factura en moneda Dólares.`;
            ruta = `respuesta-precalifica/${this.evalua.controls["Adq"].value}`;
            this.enviarSms();
          } else {
            this.arrDataAdjunto[0].evaluacion = `¡Hola! Tu cliente ${this.evalua.controls["Adq"].value} no pre-califica para la venta de tu factura.`;
            ruta = `respuesta-no-precalifica/${this.evalua.controls["Adq"].value}`;
          }
          this.enviarCorreo();
          this.respuesta = true;
          this.riesgoService.Respuesta = this.respuesta;
          this.loading = false;
          this.loadingPrincipal = false;
          this.router.navigate([ruta]);
        }
      },
      (err) => {
        this.respuesta = false;
        this.riesgoService.Respuesta = this.respuesta;
        this.loading = false;
        this.arrDataAdjunto[0].evaluacion = `¡Hola! Tu cliente ${this.evalua.controls["Adq"].value} no pre-califica para la venta de tu factura.`;
        this.enviarCorreo();
        this.loadingPrincipal = false;
        this.router.navigate([`respuesta-no-precalifica/${this.evalua.controls["Adq"].value}`]);
      }
    );

  }

  obtenerPersona() {
    let bodyObtenerPersona = {
      'Tipo_Documento_Identidad': '',
      'NroDoc': ''
    }
    if (this.evalua.controls['Tipo_Documento_Identidad'].value) {
      bodyObtenerPersona.Tipo_Documento_Identidad = this.evalua.controls['Tipo_Documento_Identidad'].value;
      bodyObtenerPersona.NroDoc = this.evalua.controls['Nro_Documento_Identidad'].value;
    } else {
      return;
    }
    if (bodyObtenerPersona.Tipo_Documento_Identidad == 'D' && this.evalua.controls['Nro_Documento_Identidad'].value) {
      this.loading = true;
      this.loadingSentinel = true;
      this.empresasService.obtenerPersonaRiesgo(bodyObtenerPersona)
        .subscribe(res => {
          this.persona = res as Persona;
          if (this.persona["message"]) {
            this.loading = false;
            this.loadingSentinel = false;
            this.evalua.controls['Nro_Documento_Identidad'].setValue('');
          } else {
            this.evalua.controls['Nombre_Completo'].setValue(this.persona.PrimerNombre + ' ' + this.persona.SegundoNombre + ' ' + this.persona.ApellidoPaterno + ' ' + this.persona.ApellidoMaterno);
            this.loading = false;
            this.loadingSentinel = false;
          }
        }, error => {
          let message;
          if (error.status == 0) {
            message = "Servicio caído, contactarse con el área de soporte.";
          } else {
            message = "Ocurrió un error. Por favor contactarse con el área de soporte.";
          }
          this.loading = false;
          this.loadingSentinel = false;
        })
    } else {
      return;
    }
  }

  enviarSms() {
    this.generarCodigoValidacion(1000, 9999);
    this.data = {
      numero: this.evalua.get("Cel").value,
      mensaje: "Su código de validación es " + this.codValid,
    };

    this.notificacionService.sendSms(this.data).subscribe(
      (res) => { },
      (error) => { }
    );
    this.encryptedText = this.encryptDecryptService.encrypt("" + this.codValid);
    localStorage.setItem("codValid", "" + this.encryptedText);
  }

  generarCodigoValidacion(min: number, max: number) {
    this.codValid = Math.floor(Math.random() * (max - min + 1) + min);
  }

  enviarCorreo() {
    this.arrDataCorreo = {
      "to": [{
        "email": "info@digitalfactoring.pe", // correo de comercial
        //"email": "nojeda@digitalfactoring.pe", // correo de prueba
        "nombre": "Comercial"
      }],
      "asunto": "Solicitud evalúa tu factura - Digital Holding",
      "contenido": this.generarPlantillaHtmlCorreo()
    };
    this.notificacionService.sendEmail(this.arrDataCorreo).subscribe(
      res => {
        console.log("Res send email: ", res);
      }, err => {
        console.log("Error send email: ", err);
      }
    );
  }
  changeClient(value) {
    this.evalua.controls['Nro_Documento_Identidad'].setValue('');
    this.evalua.controls['Nombre_Completo'].setValue('');
    const ctrl = this.evalua.get('Nombre_Completo');
    if (this.evalua.controls['Tipo_Documento_Identidad'].value == 'D') {
      ctrl.disable();
    }else{
      ctrl.enable();
    }
}

  clear(){
    this.evalua.controls['Prov'].setValue('');
    this.evalua.controls['Adq'].setValue('');
    this.evalua.controls['Cel'].setValue('');
    this.evalua.controls['Correo'].setValue('');
    this.evalua.controls['Nro_Documento_Identidad'].setValue('');
    this.evalua.controls['Nombre_Completo'].setValue('');
  }

  generarPlantillaHtmlCorreo() {
    this.arrDataAdjunto[0].rucProveedor = this.evalua.controls["Prov"].value;
    this.arrDataAdjunto[0].rucAdquirente = this.evalua.controls["Adq"].value;
    this.arrDataAdjunto[0].celular = this.evalua.controls["Cel"].value;
    this.arrDataAdjunto[0].correo = this.evalua.controls["Correo"].value;
    this.html = `<div><p>DATOS DE EVALUACIÓN</p>`;
    this.html += `<div><ul>`;
    this.html += `<li>RUC PROVEEDOR: ${this.arrDataAdjunto[0].rucProveedor}</li>`;
    this.html += `<li>RUC ADQUIRENTE: ${this.arrDataAdjunto[0].rucAdquirente}</li>`;
    this.html += `<li>CELULAR: ${this.arrDataAdjunto[0].celular}</li>`;
    this.html += `<li>CORREO: ${this.arrDataAdjunto[0].correo}</li>`;
    this.html += `<li>NUMERO DOCUMENTO : ${this.evalua.controls["Nro_Documento_Identidad"].value}</li>`;
    this.html += `<li>NOMBRES: ${this.evalua.controls["Nombre_Completo"].value}</li>`;
    this.html += `<li>EVALUACION: ${this.arrDataAdjunto[0].evaluacion}</li>`;
    this.html += `</ul></div></div>`;
    return this.html;
  }
}
